const IconBell = ({ color = 'white' }) => (
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 15.4478C0 8.79775 5.37191 3.4082 12.0002 3.4082C18.6284 3.4082 24.0003 8.79775 24.0003 15.4478H0Z"
            fill={color}
        />
        <path
            d="M12.773 4.15402C12.8786 2.21684 14.3091 2.18337 14.3091 2.18337V0.75H9.69141V2.17036C9.69141 2.17036 11.1219 2.20382 11.2276 4.14101L12.773 4.15402Z"
            fill={color}
        />
        <path
            d="M21.5877 15.4473H2.41263C2.41263 16.2876 1.73257 16.9699 0.895009 16.9699H0V19.2494H24.0003V16.9699H23.1053C22.2678 16.9699 21.5877 16.2876 21.5877 15.4473Z"
            fill={color}
        />
    </svg>
);

export default IconBell;
